import { useState, useEffect } from 'react';
import { fetchTokenComments, type TokenComment } from '../utils/tokenComments';

/**
 * Hook to fetch comments for a token from Supabase
 */
export function useTokenComments(tokenAddress: string | undefined, limit: number = 20) {
  const [comments, setComments] = useState<TokenComment[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    if (!tokenAddress) {
      setComments([]);
      return;
    }

    const loadComments = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchTokenComments(tokenAddress, limit);
        setComments(data);
      } catch (err) {
        console.error('[useTokenComments] Error:', err);
        setError(err instanceof Error ? err.message : 'Failed to load comments');
        setComments([]);
      } finally {
        setLoading(false);
      }
    };

    loadComments();
  }, [tokenAddress, limit, refreshTrigger]);

  const refetch = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return { comments, loading, error, refetch };
}

